<template>
    <div class="topheader-modal">
        <div class="topheader-modal__mask"></div>
        <div class="topheader-modal__modal">
            <div class="topheader-modal__modal-header">
                <span class="topheader-modal__modal-title">请选择备考目标</span>
                <span class="topheader-modal__modal-jump-next" @click="handleClickToJump">跳过</span>
            </div>
            <div class="topheader-modal__modal-body">
                <div
                    :class="[
                        'topheader-modal__select-item',
                        selectedList.some((_item) => _item.id === item.id) ? 'active' : '',
                    ]"
                    :style="{
                        border: selectedList.some((_item) => _item.id === item.id) ? '1px solid #02b99d' : 'none',
                    }"
                    v-for="item in labelList"
                    @click="handleSelect(item)"
                    :key="item.id"
                >
                    {{ item.className }}
                </div>
            </div>
            <div class="topheader-modal__modal-bottom">
                <div
                    :class="[`topheader-modal__modal-button`, buttonDisabled ? 'disabled' : '']"
                    @click="handleConfirm"
                >
                    确定
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getInterestLabel, saveInterestLabel } from '../../services';
//  TODO： 之后如果存在复用情况，再考虑做成插件

function joinStr(current, targetStr) {
    return current ? `,${targetStr}` : targetStr;
}

export default {
    props: ['userId'],
    data() {
        return {
            labelList: [],
            selectedList: [],
        };
    },
    computed: {
        buttonDisabled() {
            return !this.selectedList.length;
        },
    },
    methods: {
        handleClickToJump() {
            this.$emit('cancel');
        },
        handleConfirm() {
            if (this.buttonDisabled) {
                return;
            }
            const data = this.selectedList.reduce(
                (result, item) => {
                    result.classIds += joinStr(result.classIds, item.id);
                    result.classNames += joinStr(result.classNames, item.className);
                    result.productOnlineIds += joinStr(result.productOnlineIds, item.businessId);
                    return result;
                },
                {
                    classIds: '',
                    classNames: '',
                    kooUserId: 0,
                    productOnlineIds: '',
                },
            );
            data.kooUserId = this.userId;
            saveInterestLabel({ ...data, scene: 'guonei_Mzhan' })
                .then((res) => {
                    if (res.code === 0) {
                        this.changeVisible(false);
                    } else {
                        this.$toast({ msg: res.message });
                    }
                })
                .catch((err) => {
                    this.$toast({ msg: err.message });
                });
        },
        handleSelect(currentItem) {
            if (this.selectedList.some((item) => item.id === currentItem.id)) {
                this.selectedList = this.selectedList.filter((item) => item.id !== currentItem.id);
            } else {
                if (this.selectedList.length >= 3) {
                    this.$toast({ msg: '最多仅可选择三个备考目标哦！', style: { whiteSpace: 'nowrap' } });
                    return;
                }
                this.selectedList.push(currentItem);
            }
        },
        changeVisible(_visible) {
            this.$emit('changeVisible', _visible);
        },
    },
    mounted() {
        getInterestLabel().then((res) => {
            if (res && res.status === 0) {
                this.labelList = res.data.filter((item) => item.className !== '考博');
            }
        });
    },
};
</script>
<style lang='scss' scoped>
.topheader-modal {
    &__mask {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #000000;
        opacity: 0.7;
        z-index: 99;
    }
    &__modal {
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 590px;
        z-index: 100;
        background-color: #ffffff;
        border-radius: 12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
    }
    &__modal-header {
        width: 100%;
        text-align: center;
        position: relative;
        border-bottom: 2px solid #e8e9ee;
    }
    &__modal-title {
        font-size: 36px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #2b2d44;
        line-height: 114px;
    }
    &__modal-jump-next {
        position: absolute;
        right: 40px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 24px;
        font-weight: 400;
        color: #969fa9;
        cursor: pointer;
    }
    &__modal-body {
        padding-top: 25px;
    }
    &__select-item {
        position: relative;
        box-sizing: border-box;
        text-align: center;
        margin: 15px auto;
        width: 480px;
        height: 80px;
        line-height: 80px;
        background: #f1f3f8;
        border-radius: 12px;
        font-size: 32px;
        font-weight: 400;
        color: #2b2d44;
        &.active {
            font-weight: 500;
            color: #02b99d;
            font-size: 32px;
            background: #f6fdfc;
            &::after {
                content: '';
                position: absolute;
                width: 41px;
                height: 41px;
                right: 0;
                bottom: 0;
                background-image: url(../../i/modal-select-icon.png);
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }
        }
    }
    &__modal-bottom {
        padding: 50px 0;
    }
    &__modal-button {
        text-align: center;
        width: 480px;
        height: 88px;
        line-height: 88px;
        background: linear-gradient(90deg, #08c897, #00b3a0);
        box-shadow: 0px 10px 30px 0px rgba(91, 192, 154, 0.44);
        border-radius: 44px;
        font-size: 34px;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
        &.disabled {
            cursor: not-allowed;
            background: rgba(90, 191, 153, 0.44);
        }
    }
}
</style>
